import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { EventEmitter, useT } from '@progress-fe/core';
import { Box } from '@chakra-ui/react';
import { SimpleTable } from '../../tables';
import { IconButton } from '../../buttons';
import { useJsFieldFormData } from '../../../hooks';
import { tableDataUtils } from '../../../utils';
import { JsFieldInspector } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
/**
 * Component renders "/schemas/jsf-hydrotreating-diesel-catalysts-mapping-table" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is an instance of TCatalystsMappingTableFormData.
 */
const HydrotreatingDieselCatalystsMappingTableJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const { t } = useT();
    const isReadOnly = !!props.schema.readOnly;
    const { fieldConfig, fieldValues, onChangeFieldValues } = useJsFieldFormData({
        config: props.formData?.fieldConfig || null,
        values: props.formData?.fieldValues || null,
        onChange: props.onChange
    });
    const columns = useMemo(() => [
        {
            name: t('jsfields.HydrotreatingDieselCatalystsMappingTable.name'),
            type: 'string',
            align: 'left',
            readOnly: true,
            propertyName: 'reactorName'
        },
        {
            name: t('jsfields.HydrotreatingDieselCatalystsMappingTable.shelf'),
            align: 'left',
            type: 'number',
            readOnly: true,
            propertyName: 'shelf'
        },
        {
            name: t('jsfields.HydrotreatingDieselCatalystsMappingTable.catalyst'),
            align: 'left',
            type: 'select',
            options: fieldConfig?.catalysystsOptions,
            isReadOnly: isReadOnly,
            propertyName: 'catalystId'
        },
        {
            name: '',
            width: '28px',
            render: (_rowId, val) => (_jsx(IconButton, { icon: _jsx(ChevronRightIcon, { boxSize: "20px" }), isDisabled: isReadOnly, onClick: () => val.catalystId && EventEmitter.emit('SelectItem', val.catalystId) }))
        }
    ], [fieldConfig?.catalysystsOptions, isReadOnly, t]);
    const rows = useMemo(() => {
        return (fieldValues?.map((item, idx) => ({
            key: idx,
            value: item
        })) ?? []);
    }, [fieldValues]);
    const handleRowChange = useCallback((id, value) => {
        if (!fieldValues) {
            return;
        }
        const newTableValues = tableDataUtils.changeValueById(fieldValues, value, id);
        onChangeFieldValues(newTableValues);
    }, [fieldValues, onChangeFieldValues]);
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(Box, { "data-testid": "HydrotreatingDieselCatalystsMappingTable-test", "data-name": props.name, children: _jsx(SimpleTable, { rows: rows, columns: columns, isReadOnly: isReadOnly, noItemsTitle: t('jsfields.HydrotreatingDieselReactorsTable.noItems'), onValueChange: handleRowChange }) }) }));
};
export const HydrotreatingDieselCatalystsMappingTable = memo(HydrotreatingDieselCatalystsMappingTableJsFieldFC);
//# sourceMappingURL=HydrotreatingDieselCatalystsMappingTableJsField.js.map